
// import React from "react";

// const CommunitiesSection = () => {
//   const featured = [
//     { name: "Green Valley Residency", city: "Bangalore", flats: 420, img: "https://picsum.photos/400/220?random=201" },
//     { name: "Lakeview Heights", city: "Hyderabad", flats: 360, img: "https://picsum.photos/400/220?random=202" },
//     { name: "Sunrise Meadows", city: "Pune", flats: 520, img: "https://picsum.photos/400/220?random=203" },
//   ];
//   return (
//     <section id="communities" className="py-5 bg-light">
//       <div className="container">
//         <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
//           <div>
//             <h2 className="fw-bold text-primary-label">Communities Using Lupie Service App</h2>
//             <p className="text-muted mb-0">Trusted across major cities and RWA associations.</p>
//           </div>
//           <a href="#register" className="btn btn-outline-teal">List Your Community</a>
//         </div>

//         <div className="row g-4">
//           {featured.map((c, i) => (
//             <div key={i} className="col-12 col-md-6 col-lg-4">
//               <div className="card h-100 shadow-sm">
//                 <img src={c.img} className="card-img-top" alt={`${c.name} cover`} />
//                 <div className="card-body">
//                   <h5 className="card-title">{c.name}</h5>
//                   <p className="card-text text-muted">{c.city} • {c.flats} flats</p>
//                   <a href="#register" className="btn btn-sm primary-cta">Get Started</a>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// };

// export default CommunitiesSection;


import React from "react";
import "./communities.mobile.css"; // <-- add this small CSS file (see below)

const CommunitiesSection = () => {
  const featured = [
    { name: "Green Valley Residency", city: "Bangalore", flats: 420, img: "https://picsum.photos/400/220?random=201" },
    { name: "Lakeview Heights", city: "Hyderabad", flats: 360, img: "https://picsum.photos/400/220?random=202" },
    { name: "Sunrise Meadows", city: "Pune", flats: 520, img: "https://picsum.photos/400/220?random=203" },
  ];

  return (
    <section id="communities" className="py-5 bg-light">
      <div className="container">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
          <div>
            <h2 className="fw-bold text-primary-label">Communities Using Lupie Service App</h2>
            <p className="text-muted mb-0">Trusted across major cities and RWA associations.</p>
          </div>
          <a href="#register" className="btn btn-outline-teal">List Your Community</a>
        </div>

        {/* --- MOBILE (< md): horizontally scrollable card rail --- */}
        <div className="d-md-none">
          <div className="comm-rail" aria-label="Featured communities">
            {featured.map((c, i) => (
              <article key={i} className="comm-card">
                <img
                  src={c.img}
                  className="comm-img"
                  alt={`${c.name} cover`}
                  loading="lazy"
                />
                <div className="comm-body">
                  <h5 className="comm-title">{c.name}</h5>
                  <p className="comm-sub text-muted mb-2">
                    {c.city} • {c.flats} flats
                  </p>
                  <a href="#register" className="btn btn-sm primary-cta">Get Started</a>
                </div>
              </article>
            ))}
          </div>
        </div>

        {/* --- DESKTOP/TABLET (>= md): your original grid --- */}
        <div className="row g-4 d-none d-md-flex">
          {featured.map((c, i) => (
            <div key={i} className="col-12 col-md-6 col-lg-4">
              <div className="card h-100 shadow-sm">
                <img src={c.img} className="card-img-top" alt={`${c.name} cover`} loading="lazy" />
                <div className="card-body">
                  <h5 className="card-title">{c.name}</h5>
                  <p className="card-text text-muted">{c.city} • {c.flats} flats</p>
                  <a href="#register" className="btn btn-sm primary-cta">Get Started</a>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default CommunitiesSection;
